/**
 * «Talabnomalar» sahifasining MANZILDAGI holati.
 *
 * Tanlangan ko'rinish va bildirgi bo'limi manzilda turadi:
 * `/requisitions?view=backorders&tab=queue`. Ilgari ular komponent ichida
 * edi va sahifa yangilanganda odam har safar «Talabnomalar» ga qaytib
 * tushardi — skladchi esa kuniga o'nlab marta aynan bildirgilarga kiradi.
 *
 * Tekshiruv MAJBURIY: manzilni odam ham yozishi mumkin va noto'g'ri qiymat
 * (`?tab=abc`) jimgina tashlab yuboriladi, sahifa esa yiqilmaydi.
 */

export const REQUISITIONS_VIEWS = ['requisitions', 'backorders'] as const;
export type RequisitionsView = (typeof REQUISITIONS_VIEWS)[number];

export const BACKORDER_TABS = ['queue', 'ready', 'mine'] as const;
export type BackorderTab = (typeof BACKORDER_TABS)[number];

export interface RequisitionsSearch {
  view?: RequisitionsView;
  tab?: BackorderTab;
}

const pick = <T extends string>(allowed: readonly T[], raw: unknown): T | undefined =>
  typeof raw === 'string' && (allowed as readonly string[]).includes(raw) ? (raw as T) : undefined;

export const parseRequisitionsSearch = (search: Record<string, unknown>): RequisitionsSearch => {
  const view = pick(REQUISITIONS_VIEWS, search['view']);
  const tab = pick(BACKORDER_TABS, search['tab']);
  return {
    /* Standart qiymat manzilga YOZILMAYDI: `/requisitions` toza qoladi va
       eski havolalar o'zgarmaydi. */
    ...(view === undefined || view === 'requisitions' ? {} : { view }),
    /* Bo'lim faqat bildirgilar ko'rinishida ma'noga ega. */
    ...(view === 'backorders' && tab !== undefined ? { tab } : {}),
  };
};
